import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import CheckIcon from '@8x8/oxygen-icon/icons/CheckCircleSolidIcon';

const StyledCheckIcon = styled(CheckIcon).attrs({
  color: '#31B76A',
})`
  align-self: baseline;
  flex-shrink: 0;
  margin-right: 10px;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: ${props => props.fontSize}px;
  color: ${({ theme }) => theme.lightFont};
`;

const Feature = ({ boldText, text, iconSize, fontSize }) => (
  <Item fontSize={fontSize}>
    <StyledCheckIcon size={iconSize} />
    <span>{boldText && <><b>{boldText}</b>&nbsp;</>}<span>{text}</span></span>
  </Item>
);

Feature.propTypes = {
  boldText: PropTypes.string,
  text: PropTypes.string,
  iconSize: PropTypes.number,
  fontSize: PropTypes.number,
};

Feature.defaultProps = {
  iconSize: 15,
  fontSize: 15,
};

export default Feature;
